import { forwardRef } from "react";
import { cx } from "shared/utils";
import { useMentionHandler } from "./hooks/useMentionHandler";
import { LiteTextEditorProps } from "shared/components/Editor/core/types/editor";
import { EditorRefApi } from "shared/components/Editor/core/types/editor";
import { LiteTextEditorWithRef } from "shared/components/Editor";

type LiteTextEditorWrapperProps = Omit<
  LiteTextEditorProps,
  "mentionHandler"
> & {
  editable: boolean;
  disableMentions?: boolean;
  applicationId?: string;
  propertyName?: string;
};

export const LiteTextEditor = forwardRef<
  EditorRefApi,
  LiteTextEditorWrapperProps
>((props, ref) => {
  const {
    containerClassName,
    editable,
    disableMentions,
    applicationId,
    propertyName,
    ...rest
  } = props;
  const mentionHandler = useMentionHandler({ applicationId, propertyName });

  return (
    <LiteTextEditorWithRef
      ref={ref}
      editable={editable}
      mentionHandler={disableMentions ? undefined : mentionHandler}
      {...rest}
      containerClassName={cx(containerClassName, "relative")}
    />
  );
});

LiteTextEditor.displayName = "LiteTextEditor";
